import React from "react";
import { Skeleton } from "@mantine/core";
import useOrgBrief from "./useOrgBrief";
import OrgBriefCard from "./OrgBriefCard";
import OrgBriefChartCard from "./OrgBriefChartCard";
import css from "./OrgBrief.module.scss";

const QUIET_MESSAGES = {
  nothing_stands_out:
    "Nothing in your team's meetings stands out as a problem for this period. Keep the current rhythm.",
  too_few_meetings: "There are too few meetings in this period to say anything useful yet.",
};

function LoadingRow() {
  return (
    <div className={css.row} aria-busy="true">
      <section className={`${css.card} ${css.summaryCard}`}>
        <div className={css.kicker}>
          <span className={css.dot} aria-hidden="true" />
          Reading your team's meetings, tasks and week ahead
        </div>
        <Skeleton height={20} mt={18} radius="sm" />
        <Skeleton height={20} mt={10} radius="sm" />
        <Skeleton height={20} mt={10} width="70%" radius="sm" />
      </section>
      <section className={`${css.card} ${css.chartCard}`}>
        <Skeleton height={16} width="40%" radius="sm" />
        <Skeleton height={170} mt={20} radius="md" />
      </section>
    </div>
  );
}

// The top row of the Organization page: what is going wrong and what to do
// this week, with the chart that proves it. On an error the row stays hidden
// and the rest of the page works as before.
export default function OrgBriefRow({ uid, snapshotDate, snapshotUpdatedAt, period, perspective }) {
  const { data, isLoading, isError } = useOrgBrief({
    uid,
    snapshotDate,
    snapshotUpdatedAt,
    period,
    perspective,
  });

  if (isLoading) return <LoadingRow />;
  if (isError || !data) return null;

  if (data.status !== "ready" || !data.brief) {
    const message = QUIET_MESSAGES[data.status];
    return message ? (
      <section className={`${css.card} ${css.quiet}`}>
        <div className={css.kicker}>
          <span className={css.dot} aria-hidden="true" />
          This period
        </div>
        <p>{message}</p>
      </section>
    ) : null;
  }

  return (
    <div className={css.row}>
      <OrgBriefCard brief={data.brief} uid={uid} />
      <OrgBriefChartCard chart={data.brief.chart} />
    </div>
  );
}
